import { loadMorePosts } from "./getNewCarts"
document.addEventListener('apaprtment_getProducts', function({detail: {postType = '', callback = null, filters = {}, receivedCount = 0} = {}}) {
	loadMorePosts(postType, callback, filters, receivedCount);
})